module.exports = __webpack_public_path__ + "img/bonus-bg.c1eeb2ed.png";